const bwStyles = {
  baseline_required: { text: "Baseline Labs Generally Required", cls: "text-red-700 bg-red-50 border-red-200" },
  recent_recommended: { text: "Recent Labs Recommended", cls: "text-amber-700 bg-amber-50 border-amber-200" },
  provider_determines: { text: "Provider Determines Testing", cls: "text-sky-700 bg-sky-50 border-sky-200" },
};

const regStyles = {
  fda_approved:  { text: "FDA-Approved Use",         cls: "text-green-800 bg-green-50 border-green-200" },
  off_label:     { text: "May Be Used Off-Label",    cls: "text-indigo-800 bg-indigo-50 border-indigo-200" },
  compounded:    { text: "Compounded Prescription",  cls: "text-orange-800 bg-orange-50 border-orange-200" },
  emerging:      { text: "Emerging Therapy",         cls: "text-pink-800 bg-pink-50 border-pink-200" },
  educational:   { text: "Educational Only",         cls: "text-slate-700 bg-slate-100 border-slate-200" },
};

const evStyles = {
  established: { text: "Established Human Evidence",  cls: "text-amber-800 bg-amber-50 border-amber-200" },
  moderate:    { text: "Moderate Human Evidence",     cls: "text-amber-700 bg-amber-50 border-amber-200" },
  limited:     { text: "Limited Human Evidence",      cls: "text-amber-800 bg-amber-50 border-amber-200" },
  preclinical: { text: "Primarily Preclinical",       cls: "text-slate-700 bg-slate-100 border-slate-200" },
};

export function BloodworkBadge({ level, testId = "badge-bloodwork" }) {
  const s = bwStyles[level] || bwStyles.provider_determines;
  return <span data-testid={testId} className={`vv-badge border ${s.cls}`}>{s.text}</span>;
}

export function RegulatoryBadge({ status, testId = "badge-regulatory" }) {
  const s = regStyles[status] || regStyles.educational;
  return <span data-testid={testId} className={`vv-badge border ${s.cls}`}>{s.text}</span>;
}

export function EvidenceBadge({ level, testId = "badge-evidence" }) {
  const s = evStyles[level] || evStyles.limited;
  return <span data-testid={testId} className={`vv-badge border ${s.cls}`}>{s.text}</span>;
}

export function RouteBadge({ route, testId = "badge-route" }) {
  return <span data-testid={testId} className="vv-badge border text-stone-700 bg-stone-100 border-stone-200 capitalize">{route}</span>;
}
